import React, { useEffect } from 'react';

import SurveyRunner from './SurveyRunner';
import { SURVEYS, SURVEY_PAGE_TITLE } from './survey.config';
import poweredByDqLogo from './PoweredByDQ_white.png';
import './survey.css';

/**
 * SurveyApp — the whole survey experience, mounted on its own (no router, no host-app
 * contexts). `route` comes from resolveSurveyRoute():
 *   { key: 'student' }  → that survey
 *   { key: null }       → the chooser (bare survey host)
 */

const NotFound = () => {
    useEffect(() => { document.title = 'Survey not available'; }, []);
    return (
        <div className="dq-survey">
            <header className="dqs-header"><div className="dqs-header-row"><div className="dqs-brand"><img src={poweredByDqLogo} alt="Powered by DQ" className="dqs-brand-logo" /><span className="dqs-brand-divider" aria-hidden="true" /><span className="dqs-brand-title">{SURVEY_PAGE_TITLE}</span></div></div><div className="dqs-stripe" aria-hidden="true" /></header>
            <main className="dqs-main"><div className="dqs-column"><div className="dqs-card dqs-stack dqs-gap-14"><span className="dqs-kicker">Unavailable</span><h2 className="dqs-h2">Survey not found</h2><p className="dqs-helper">This survey is not available.</p></div></div></main>
        </div>
    );
};

const Chooser = ({ base }) => {
    useEffect(() => { document.title = SURVEY_PAGE_TITLE; }, []);
    return (
        <div className="dq-survey">
            <header className="dqs-header">
                <div className="dqs-header-row">
                    <div className="dqs-brand"><img src={poweredByDqLogo} alt="Powered by DQ" className="dqs-brand-logo" /><span className="dqs-brand-divider" aria-hidden="true" /><span className="dqs-brand-title">{SURVEY_PAGE_TITLE}</span></div>
                </div>
                <div className="dqs-stripe" aria-hidden="true" />
            </header>
            <main className="dqs-main">
                <div className="dqs-column"><div className="dqs-card dqs-stack dqs-gap-32"><div className="dqs-stack dqs-gap-14"><span className="dqs-kicker">Welcome</span><h1 className="dqs-h1">Which survey is yours?</h1><p className="dqs-helper">Select the survey that matches your role to get started.</p></div>
                    <div className="dqs-choices">
                        {SURVEYS.map((s) => (
                            <a key={s.key} className="dqs-choice" href={`${base}/${s.key}`}>
                                {s.label}
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                                    <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </a>
                        ))}
                    </div></div>
                </div>
            </main>
        </div>
    );
};

const SurveyApp = ({ route }) => {
    if (!route.key) return <Chooser base={route.base} />;
    const survey = SURVEYS.find((s) => s.key === route.key);
    if (!survey) return <NotFound />;
    // ?preview=<token>: an unpublished draft, opened from the admin portal.
    let previewToken = null;
    try { previewToken = new URLSearchParams(window.location.search).get('preview'); } catch (e) { /* old browser */ }
    return <SurveyRunner surveyCode={survey.survey_code} pageTitle={survey.pageTitle} previewToken={previewToken} />;
};

export default SurveyApp;
